export default __webpack_public_path__ + "fe2c6f1781dc56a48af92c69693da781.svg";